import type {
  BuildingMetrics,
  NeighborMetrics,
} from '../NeighborhoodContextTab.types'

export const extractBuildingMetrics = (building: any): BuildingMetrics => ({
  buildingHeight: building.building_height || building.height || 0,
  buildingArea: building.area || building.building_area || 0,
  buildingVolume: building.building_volume || 0,
})

export const extractNeighborMetrics = (building: any): NeighborMetrics => ({
  neighborsHeightMean: building.neighbors_building_height_mean || 0,
  neighborsHeightMax: building.neighbors_building_height_max || 0,
  neighborsAreaMean: building.neighbors_building_area_mean || 0,
  neighborsAreaMax: building.neighbors_building_area_max || 0,
  neighborsVolumeMean: building.neighbors_building_volume_mean || 0,
  neighborsVolumeMax: building.neighbors_building_volume_max || 0,
  neighborsCount: building.neighbors_building_nb || 0,
})

export const hasNeighborData = (neighborMetrics: NeighborMetrics): boolean =>
  neighborMetrics.neighborsHeightMean > 0 ||
  neighborMetrics.neighborsAreaMean > 0 ||
  neighborMetrics.neighborsVolumeMean > 0
